import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ExportHubService } from '../service/export-hub.service';




@Component({
    selector: 'app-popup-report',
    templateUrl: './popup-report.component.html',
    styleUrls: ['./popup-report.component.css'],
})

export class PopupReportComponent implements OnInit {

    reportDataCount= 0;
    public email: string;
    public exportMediaFlag: boolean = false;
    public technicalDataSheetFlag: boolean = false;
    public safetyDataSheetFlag: boolean = false;
    public installInstructionsFlag: boolean = false;
    public brochureFlag: boolean = false;
    public userManualFlag: boolean = false;
    public isCompetitor: boolean = false;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<PopupReportComponent>, public exportService: ExportHubService,
    ) {
             this.reportDataCount = data['count'];
    }
    ngOnInit() {
    }
    

    cancel() {
        this.dialogRef.close('cancel');
    }
    generateReport() {
        this.dialogRef.close(
            {
                email: this.email,
                exportMediaFlag: this.exportMediaFlag,
                technicalDataSheetFlag: this.technicalDataSheetFlag,
                safetyDataSheetFlag: this.safetyDataSheetFlag,
                installInstructionsFlag: this.installInstructionsFlag,
                brochureFlag: this.brochureFlag,
                userManualFlag: this.userManualFlag,
                isCompetitor: this.isCompetitor
            }
        );
    }
}